import React, {useMemo} from 'react';

import {NumberInput} from '../components/NumberInput';
import {BucketCustomization} from '../types';
import {normalizeNumber} from './utils/numberNormalization';

export const NumberRangeInput = ({
  minField,
  maxField,
  minValue,
  maxValue,
  updateSetting,
  minDisabled,
  maxDisabled,
}: {
  minField: 'bucketMin';
  maxField: 'bucketMax';
  minValue: number | undefined;
  maxValue: number | undefined;
  minDisabled?: boolean;
  maxDisabled?: boolean;
  updateSetting: (settings: Partial<BucketCustomization>) => void;
}) => {
  // Format the values for consistent display and prevent flickering
  const formattedMinValue = useMemo(
    () => (minValue != null ? normalizeNumber(minValue) : undefined),
    [minValue]
  );

  const formattedMaxValue = useMemo(
    () => (maxValue != null ? normalizeNumber(maxValue) : undefined),
    [maxValue]
  );

  return (
    <div className="flex w-full gap-16">
      <NumberInput
        className="w-1/2"
        placeholder="Min"
        value={formattedMinValue}
        updateSetting={(newVal?: number) => {
          updateSetting({[minField]: newVal});
        }}
        disabled={minDisabled}
      />
      <NumberInput
        className="w-1/2"
        placeholder="Max"
        value={formattedMaxValue}
        updateSetting={(newVal?: number) => {
          updateSetting({[maxField]: newVal});
        }}
        disabled={maxDisabled}
      />
    </div>
  );
};
